import { BoardBackend } from '../../../../frontend/src/app/core/board/board';
import { CoreItemBackend, CoreItemType } from '../../../../frontend/src/app/core/core-item/core-item';
import { SubscriptionStripe } from '../../../../frontend/src/app/core/stripe/subscription.stripe';
import { WorkspaceComboBackend } from '../../../../frontend/src/app/core/workspace/workspace';
import { SuccessResponse } from '../request-response';
import { ResourceName } from '../resource-name';

// tslint:disable: variable-name
export const BoardGate = {
  resource: ResourceName.board,
  actions: {
    getAllBoardMetadataAndPersonalBoard: 'get-all-board-metadata-and-personal-board',
    updateBoard: 'update-board',
    removeUserFromWorkspace: 'remove-user-from-workspace',
    updateUnipile: 'update-unipile',
  },
};

export type BoardGateActionTypes = {
  getAllBoardMetadataAndPersonalBoard: {
    request: { workspaceId?: string };
    response: GetAllBoardMetadataAndPersonalBoardResponse;
  };
  updateBoard: {
    request: any;
    response: any;
  };
  removeUserFromWorkspace: {
    request: RemoveUserFromWorkspaceRequest;
    response: SuccessResponse;
  };
};

export interface UpdateUnipileRequest {
  workspaceId: string;
  accountId: string;
}

export interface RemoveUserFromWorkspaceRequest {
  workspaceId: string;
  userId: string;
}

export interface GetAllBoardMetadataAndPersonalBoardResponse {
  isMaintainanceMode?: boolean;
  maintainanceText?: string;
  myPersonalBoard: BoardBackend;
  itemBackendList: CoreItemBackend[];
  myWorkspaceList: WorkspaceComboBackend[];
  fileList: OpenAiFileObject[];
  subscription?: SubscriptionStripe;
  loadedCoreItemTypeList?: CoreItemType[];
}

export interface OpenAiFileObject {
  /**
   * The file identifier, which can be referenced in the API endpoints.
   */
  id: string;

  /**
   * The size of the file, in bytes.
   */
  bytes: number;

  /**
   * The Unix timestamp (in seconds) for when the file was created.
   */
  created_at: number;

  /**
   * The name of the file.
   */
  filename: string;

  /**
   * The object type, which is always `file`.
   */
  object: 'file';

  /**
   * The intended purpose of the file. Supported values are `fine-tune`,
   * `fine-tune-results`, `assistants`, and `assistants_output`.
   */
  purpose: 'fine-tune' | 'fine-tune-results' | 'assistants' | 'assistants_output';

  /**
   * Deprecated. The current status of the file, which can be either `uploaded`,
   * `processed`, or `error`.
   */
  status: 'uploaded' | 'processed' | 'error';

  /**
   * Deprecated. For details on why a fine-tuning training file failed validation,
   * see the `error` field on `fine_tuning.job`.
   */
  status_details?: string;
}
